@if (course) {
  @if (mode == 'mobile') {
    <div class="dialog-container">
      <div class="list-column">
        <app-logo/>
        <div class="typo-h1 spacing-top">{{ course.title }}</div>
        <div class="label spacing-top">
          <mat-icon>home</mat-icon>
          <div class="body-text-bold">{{ locationInfo() }}</div>
        </div>
        <div class="left-aligned spacing-top">
          <app-text-button (click)="back()" [text]="'button.change' | transloco" colorVariant="tertiary" leadingIcon="edit" type="rounded"/>
        </div>
        <div class="typo-h1 spacing-top">{{ 'courses.select' | transloco }}</div>
        <div class="card-description color-900">{{ 'courses.selectionHint' | transloco }}</div>
        <div class="scroll spacing-top">
          @for (dto of groupAppointments; track dto.dto!.id) {
            <div class="appointment-slot" (click)="toggleSelection(dto)">
              <div class="columnLeft">
                <div class="firstrow">
                  <div class="body-text-bold color-secondary">{{ getFormatedDate(dto.dto!.start) }}</div>
                  <div class="body-text-bold spacing-left">{{ getFormatedTime(dto.dto!) }}</div>
                </div>
                @if(course.hideTherapist != true){
                  <div class="body-text">{{ getAppointmentInfo(dto.dto!) }}</div>
                }
                @if(dto.dto!.bookedOut == true){
                  <div class="body-text-small color-cancel">{{ getBookingInfo(dto.dto!) }}</div>
                }
                @else{
                  <div class="body-text-small color-success">{{ getBookingInfo(dto.dto!) }}</div>
                }
              </div>
              <div class="columnRight">
                @if(dto.dto!.bookedOut == true){
                  <mat-checkbox [checked]="dto.isChecked" disabled></mat-checkbox>
                }
                @else{
                  <mat-checkbox [checked]="dto.isChecked" (click)="$event.preventDefault()"></mat-checkbox>
                }
              </div>
            </div>
          }
        </div>

        <div class="fixed">
          <app-text-button (click)="showBooking()" [text]="'courses.book' | transloco" colorVariant="primary" leadingIcon="check_circle" type="rounded"/>
        </div>
      </div>
    </div>
  } @else {
    <div class="dialog-container">
      <div class="page-row-blank">
        <div class="column">
          <app-logo/>
          <div class="typo-h1 spacing-top">{{ 'courses.selection' | transloco }}</div>
          <div class="card-image-container spacing-top">
            @if (course.imageUrl != null) {
              <img src="{{course.imageUrl}}" alt="course"/>
            }
            <div class="card-price-tag">{{ course.price }} CHF</div>
          </div>
          <div class="typo-h1 spacing-top">{{ course.title }}</div>
          <div class="label spacing-top">
            <mat-icon>home</mat-icon>
            <div class="body-text-bold">{{ locationInfo() }}</div>
          </div>
          <div class="card-description spacing-top color-900">{{ getDescription() }}</div>
          <div class="left-aligned spacing-top">
            <app-text-button (click)="back()" [text]="'button.change' | transloco" colorVariant="tertiary" leadingIcon="edit" type="rounded"/>
          </div>
        </div>
        <mat-divider class="primary" vertical/>
        <div class="list-column">
          <div class="typo-h1">{{ 'courses.select' | transloco }}</div>
          <div class="card-description color-900">{{ 'courses.selectionHint' | transloco }}</div>
          <div class="scroll spacing-top">
            @for (dto of groupAppointments; track dto.dto!.id) {
              <div class="appointment-slot" (click)="toggleSelection(dto)">
                <div class="columnLeft">
                  <div class="firstrow">
                    <div class="body-text-bold color-secondary">{{ getFormatedDate(dto.dto!.start) }}</div>
                    <div class="body-text-bold spacing-left">{{ getFormatedTime(dto.dto!) }}</div>
                  </div>
                  @if(course.hideTherapist != true){
                    <div class="body-text">{{ getAppointmentInfo(dto.dto!) }}</div>
                  }
                  @if(dto.dto!.bookedOut == true){
                    <div class="body-text-small color-cancel">{{ getBookingInfo(dto.dto!) }}</div>
                  }
                  @else{
                    <div class="body-text-small color-success">{{ getBookingInfo(dto.dto!) }}</div>
                  }
                </div>
                <div class="columnRight">
                  @if(dto.dto!.bookedOut == true){
                    <mat-checkbox [checked]="dto.isChecked" disabled></mat-checkbox>
                  }
                  @else{
                    <mat-checkbox [checked]="dto.isChecked" (click)="$event.preventDefault()"></mat-checkbox>
                  }
                </div>
              </div>
            }
          </div>

          <div class="fixed">
            <app-text-button (click)="showBooking()" [text]="'courses.book' | transloco" colorVariant="primary" trailingIcon="check_circle" type="rounded"/>
          </div>
        </div>
      </div>
    </div>
  }
}
